/**
 * @fileoverview Default values for time/date-related entities.
 *
 * NOTE: Please don't import this file directly, but use the index file instead.
 */
import { DefaultText } from "./primitives";

/**
 * Zero duration string in the ISO 8601 format.
 */
export const DefaultDuration = "PT0S";

/**
 * Default time string.
 */
export const DefaultTime = DefaultText;

/**
 * Current date in the ISO 8601 format.
 *
 * @returns YYYY-MM-DD
 */
export const DefaultDateString = new Date().toISOString().slice(0, 10);

/**
 * Current date and time in the ISO 8601 format (UTC, indicated by the trailing 'Z').
 *
 * @returns YYYY-MM-DDTHH:MM:SS.SSSZ
 */
export const DefaultInstantString = new Date().toISOString();

/**
 * Current UTC date and time in the ISO 8601 format, (formatted like a local date i.e without the trailing 'Z')
 *
 * @returns YYYY-MM-DDTHH:MM:SS.SSS
 */
export const DefaultLocalDateTime = DefaultInstantString.substring(0, DefaultInstantString.length - 1);
